import React, { Component } from "react";
import Dropzone from "../dropzone/Dropzone";
import Dropzone2 from "../dropzone/Dropzone2";
import {
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  MenuItem,
  FormControl,
  Radio,
  RadioGroup,
  FormLabel,
  Link,
  Typography,
  IconButton,
} from "@material-ui/core";
// import CheckCircle from "@material-ui/icons/CheckCircleOutline";
// import Cancel from "@material-ui/icons/HighlightOff";
import swal from "sweetalert";
import DialogActions from "@material-ui/core/DialogActions";
import NextArrow from "../assets/next-arrow.png";
import Calender from "../assets/calendar.png";
import Clock from "../assets/clock.png";
import { Formik, Form } from "formik";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { fetchMethod } from "../../FetchMethod";
import { profileImageUrl } from "../../config";
import { campaignImageUrl } from "../../config";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  campaignLogMaintain,
  getlinkedinprofiles,
  stepLogs,
} from "../Campaign/campaignQueries";
import { GetAllCampaign } from "../../Queries";
import AddLinkedinModal from "../Customers/customerLinkedinData";
import AddStepsSection from "../Campaign/StepAdd";
import store from "../../Redux/Store";
import { connect } from "react-redux";
import { API_URL } from "../../config";

class FormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      params2: [],
      formData: {},
      onButton: "true",
      message: false,
      loading: false,
      loadingData: false,
      loadingData1: false,
      textAreaData: "",
      subject: "",
      active: true,
      daysdelays: true,
      personalNoteActive: false,
      personalNoteAreaData: "",
      thanksActive: false,
      thanksAreaData: "",
      pauseStatus: "",
      fileData: [],
      starttime: "",
      currentPosition: "",
      params3: [],
      campaignType: "",
      campaignDataOptionType: "",
      EditcampaignTypeId: "",
      campaignWorkflowTypeCheck: "",
    };
  }
  componentWillMount() {
    if (this.props.editableData !== undefined) {
      localStorage.removeItem("campaignType");
      if (
        this.props.editableData.status === 1 ||
        this.props.editableData.status === 0
      ) {
        this.props.editableData.status = String(this.props.editableData.status);
      }
      if (
        this.props.editableData.abm === 1 ||
        this.props.editableData.abm === 0
      ) {
        this.props.editableData.abm = String(this.props.editableData.abm);
      }

      if (
        this.props.editableData.active === 1 ||
        this.props.editableData.active === 0
      ) {
        this.props.editableData.active = String(this.props.editableData.active);
      }
      if (
        this.props.editableData.role === "CUSTOMER" &&
        this.props.className === "userForm"
      ) {
        localStorage.setItem("type", this.props.editableData.role);
      }
      if (
        (this.props.editableData.role === "ADMIN" ||
          this.props.editableData.role === "CAMPAIGNMANAGER") &&
        this.props.className === "userForm"
      ) {
        localStorage.removeItem("type");
      }
      return this.setState(
        {
          formData: this.props.editableData,
        },
        () => {
          if (
            this.props.formConfig.title === "Add Step" &&
            this.props.editableData !== undefined
          ) {
            if (this.props.editableData.stepname === "SEND_MESSAGE") {
              this.setState({
                message: true,
                active: false,
                email: false,
                daysdelays: true,
                personalNoteActive: false,
                thanksActive: false,
              });
            } else if (this.props.editableData.stepname === "SEND_EMAIL") {
              this.setState({
                message: false,
                active: false,
                daysdelays: true,
                personalNoteActive: false,
                thanksActive: false,
                email: true,
              });
            } else if (this.props.editableData.stepname === "SEND_INVITE") {
              let { formData } = this.state;
              formData["personalmessage"] = formData["message"];
              this.setState({
                message: false,
                email: false,
                active: true,
                personalNoteActive: true,
                formData,
                daysdelays: true,
                thanksActive: false,
              });
            } else if (
              this.props.editableData.stepname === "SEND_THANKS_MESSAGE"
            ) {
              let { formData } = this.state;
              formData["replyMessage"] = formData["message"];
              this.setState({
                message: false,
                active: true,
                email: false,
                personalNoteActive: false,
                thanksActive: true,
                daysdelays: true,
              });
            } else {
              this.setState({
                message: false,
                email: false,
                active: false,
                personalNoteActive: false,
                thanksActive: false,
                daysdelays: true,
              });
            }
          }
          if (
            this.props.formConfig.title === "Add Step" &&
            this.props.editableData !== undefined
          ) {
            this.editdisplayNote(this.state.formData);
          }
          if (
            this.state.formData.customerid === null &&
            this.props.className === "userForm"
          ) {
            this.state.formData.customerid = "Select Customer";
          }
          if (
            this.state.formData.startdate !== undefined &&
            (this.props.className === "campaignForm" ||
              this.props.className === "EditCampaign")
          ) {
            const { formData } = this.state;
            var date = new Date(formData.startdate);
            var tz = date.getTimezoneOffset();
            formData.startdate = new Date(date.getTime() + tz * 60000);
            this.setState({
              formData,
              starttime: formData.startdate,
              campaignWorkflowTypeCheck: this.props.editableData.workflowtype,
            });
            store.dispatch({
              type: "CAMPAIGN_WORKFLOW_CLICK_TYPE",
              payload: this.props.editableData.workflowtype,
            });
          }
          if (
            this.props.className === "EditCampaign" &&
            this.state.formData.type !== undefined
          ) {
            localStorage.setItem("campaignType", this.state.formData.type);
            this.setState({ campaignType: this.state.formData.type });
          }

          if (
            this.props.className === "EditCampaign" &&
            this.state.formData.datafromcampaign !== undefined
          ) {
            this.setState({
              EditcampaignTypeId: this.state.formData.datafromcampaign,
            });
          }
          if (
            this.props.className === "EditCampaign" &&
            this.state.formData.status !== undefined
          ) {
            this.setState({ pauseStatus: this.state.formData.status });
          }
          if (
            this.props.formConfig.title === "Edit Campaign" ||
            this.props.formConfig.title === "AddCampaignForm"
          ) {
            this.linkedinpro();
            this.getlinkedInCampaign();
          }
        }
      );
    } else {
      if (this.props.formConfig.title === "Add Step") {
        this.setState({ active: false });
      }

      const campaignType = localStorage.getItem("campaignType");
      return this.props.formConfig.fields.map((fields) => {
        if (campaignType === "Nurture Campaign") {
          if (fields.label === "Step") {
            let data = [
              { name: "Follow Profile", value: "FOLLOW" },
              { name: "Send Message", value: "SEND_MESSAGE" },
              { name: "Send InMail", value: "SEND_EMAIL" },
            ];
            fields.data = data;
          }
        } else if (campaignType === "In mail campaign") {
          if (fields.label === "Step") {
            let data = [
              { name: "Visit Profile", value: "VISIT" },
              { name: "Follow Profile", value: "FOLLOW" },
              { name: "Send InMail", value: "SEND_EMAIL" },
            ];
            fields.data = data;
          }
        } else {
          if (fields.label === "Step") {
            let data = [
              { name: "Visit Profile", value: "VISIT" },// data 
              { name: "Follow Profile", value: "FOLLOW" },
              { name: "Send Invite", value: "SEND_INVITE" },
              { name: "Send Thanks Message", value: "SEND_THANKS_MESSAGE" },
              { name: "Send Message", value: "SEND_MESSAGE" },
              { name: "Send InMail", value: "SEND_EMAIL" },
            ];
            fields.data = data;
          }
        }
        const { name, value } = fields;
        const { formData } = this.state;
        formData[name] = value;
        this.setState({ formData });
        if (this.props.formConfig.title === "AddCampaignForm") {
          this.state.campaignWorkflowTypeCheck = "Standard";
          this.state.formData.workflowtype = "Standard";
          store.dispatch({
            type: "CAMPAIGN_WORKFLOW_CLICK_TYPE",
            payload: "Standard",
          });
        }
      });
    }
  }

  linkedinpro = () => {
    let linkedinprofileid = {
      where: {
        order: "name asc",
        customerid: this.state.formData.customerid,
        active: 1,
      },
    };
    fetchMethod(getlinkedinprofiles, linkedinprofileid)
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          params2:
            res.data.allCustomerlinkedinprofiles.Customerlinkedinprofiles,
        });
      })
      .catch((e) => console.log(e));
  };
  getlinkedInCampaign = () => {
    const filter = {
      where: {
        order: "name asc",
        linkedinid: this.state.formData.linkedinid,
        active: 1,
      },
    };

    fetchMethod(GetAllCampaign, filter)
      .then((res) => res.json())
      .then((res) => {
        let data =
          res.data.allCampaigns !== undefined && res.data.allCampaigns !== null
            ? res.data.allCampaigns.Campaigns
            : "";

        this.setState({ params3: data }, () => {
          if (
            this.state.EditcampaignTypeId !== "" &&
            this.state.EditcampaignTypeId !== undefined
          ) {
            let data = this.state.params3.filter(
              (x) => x.id == this.state.EditcampaignTypeId
            );
            let array = [];
            if (data && data[0]) {
              array.push({
                id: data[0].id,
                name: data[0].name,
              });
            }

            this.setState({
              params3: array,
            });
          }
        });
      })
      .catch((e) => console.log(e));
  };
  setPauseStatus = () => {
    swal("Are you sure you want to pause this campaign?", {
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const { formData } = this.state;
        formData["status"] = "PAUSED";
        this.setState({ formData, pauseStatus: "PAUSED" });
        const test = {
          id: { id: this.state.formData.id },
          data: { status: this.state.formData.status },
        };
        const campaignLogdata = {
          id: { id: this.state.formData.id },
          data: {
            campaignid: this.state.formData.id,
            statusaction: this.state.formData.status,
            updatedfrom: "Xseller8",
            updatedby: localStorage.getItem("id"),
          },
        };
        fetchMethod(this.props.query, test)
          .then((res) => res.json())
          .then((response) => {
            const message =
              response.data[this.props.query.definitions[0].name.value];

            if (message !== null) {
              swal({ text: "Action completed successfully", icon: "success" });
              return this.props.updateData ? this.props.updateData() : "";
            } else {
              swal("Please try again", { icon: "error" });
            }
          })
          .then((res) => {
            fetchMethod(campaignLogMaintain, campaignLogdata).then(
              (response) => {
                return response.json();
              }
            );
          })
          .catch((e) => {
            console.log(e);
            swal({ title: "Unable to reach server", icon: "warning" });
          });
      } else {
        return;
      }
    });
  };

  setEndStatus = () => {
    swal("Are you sure you want to end this campaign?", {
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const { formData } = this.state;
        formData["status"] = "COMPLETED";
        this.setState({ formData, pauseStatus: "COMPLETED" });
        const test = {
          id: { id: this.state.formData.id },
          data: { status: this.state.formData.status },
        };
        const campaignLogdata = {
          id: { id: this.state.formData.id },
          data: {
            campaignid: this.state.formData.id,
            statusaction: this.state.formData.status,
            updatedfrom: "Xseller8",
            updatedby: localStorage.getItem("id"),
          },
        };
        fetchMethod(this.props.query, test)
          .then((res) => res.json())
          .then((response) => {
            const message =
              response.data[this.props.query.definitions[0].name.value];
            if (message !== null) {
              swal({ text: "Action completed successfully", icon: "success" });
              return this.props.updateData ? this.props.updateData() : "";
            } else {
              swal("Please try again", { icon: "error" });
              return this.props.updateData ? this.props.updateData() : "";
            }
          })
          .then((res) => {
            fetchMethod(campaignLogMaintain, campaignLogdata).then(
              (response) => {
                return response.json();
              }
            );
          })
          .catch((e) => {
            console.log(e);
            swal({
              title: "Update unsuccessful",
              icon: "warning",
            });
          });
      } else {
        return;
      }
    });
  };

  setLiveStatus = () => {
    swal("Are you sure you want to resume this campaign?", {
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const { formData } = this.state;
        formData["status"] = "LIVE";
        this.setState({ formData, pauseStatus: "LIVE" });
        const test = {
          id: { id: this.state.formData.id },
          data: { status: this.state.formData.status },
        };
        const campaignLogdata = {
          id: { id: this.state.formData.id },
          data: {
            campaignid: this.state.formData.id,
            statusaction: this.state.formData.status,
            updatedfrom: "Xseller8",
            updatedby: localStorage.getItem("id"),
          },
        };
        fetchMethod(this.props.query, test)
          .then((res) => res.json())
          .then((response) => {
            const message =
              response.data[this.props.query.definitions[0].name.value];
            if (message !== null) {
              swal({ text: "Action completed successfully", icon: "success" });
              return this.props.updateData ? this.props.updateData() : "";
            } else {
              swal("Please try again", { icon: "error" });
            }
          })
          .then((res) => {
            fetchMethod(campaignLogMaintain, campaignLogdata).then(
              (response) => {
                return response.json();
              }
            );
          })
          .catch((e) =>
            swal({ title: "Unable to reach server", icon: "warning" })
          );
      } else {
        return;
      }
    });
  };
  setDeleteStatus = () => {
    swal("Are you sure you want to delete this campaign?", {
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const { formData } = this.state;
        formData["status"] = "NOTSTARTED";
        this.setState({ formData, pauseStatus: "NOTSTARTED" });
        const test = {
          id: { id: this.state.formData.id },
          data: { active: 0 },
        };
        const campaignLogdata = {
          id: { id: this.state.formData.id },
          data: {
            campaignid: this.state.formData.id,
            statusaction: this.state.formData.status,
            updatedfrom: "Xseller8",
            updatedby: localStorage.getItem("id"),
          },
        };
        fetchMethod(this.props.query, test)
          .then((res) => res.json())
          .then((response) => {
            const message =
              response.data[this.props.query.definitions[0].name.value];
            if (message !== null) {
              swal({ text: "Action completed successfully", icon: "success" });

              window.location = "/campaigns";
              return this.props.updateData ? this.props.updateData() : "";
            } else {
              swal("Please try again", { icon: "error" });
              return this.props.updateData ? this.props.updateData() : "";
            }
          })
          .then((res) => {
            fetchMethod(campaignLogMaintain, campaignLogdata).then(
              (response) => {
                return response.json();
              }
            );
          })
          .catch((e) => {
            console.log(e);
            swal({
              title: "Update unsuccessful",
              icon: "warning",
            });
          });
      } else {
        return;
      }
    });
  };

  setHubspotId = () => {
    this.setState({ loadingData1: true });
    var profileId =
      this.props.editableData !== undefined
        ? this.state.formData.id
        : "new_" + new Date().getTime() + Math.round(Math.random() * 100);
    window.open(
      API_URL +
        "/hubspot/login?profileId=" +
        profileId +
        "&customerId=" +
        store.getState().id
    );

    var timer = setInterval(() => {
      fetch(
        `${API_URL}/api/Hubspottokens/getUpdateToken?profileId=${profileId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((response) => {
          if (response.response !== "Token Not Found") {
            this.setState({ loadingData1: "Token" });
            clearInterval(timer);
            this.props.EditLinkedinData(
              (this.state.formData.hubspottoken = response.response)
            );
          } else {
            setTimeout(() => {
              clearInterval(timer);
              this.setState({ loadingData1: false });
            }, 180000);
          }
        });
    }, 3000);
  };

  setSalesforceId = () => {
    this.setState({ loadingData: true });
    var profileId = this.props.editableData
      ? this.state.formData.id
      : "new_" + new Date().getTime() + Math.round(Math.random() * 100);
    window.open(
      API_URL +
        "/salesforce/login?profileId=" +
        profileId +
        "&customerId=" +
        store.getState().id
    );

    const timer = setInterval(() => {
      fetch(
        `${API_URL}/api/Salesforcetokens/getUpdateSalesforceToken?profileId=${profileId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((response) => {
          if (response.response !== "Token Not Found") {
            this.setState({ loadingData: "Token" });
            clearInterval(timer);
            this.props.EditLinkedinData(
              (this.state.formData.salesforcetoken = response.response)
            );
          } else {
            setTimeout(() => {
              clearInterval(timer);
              this.setState({ loadingData: false });
            }, 180000);
          }
        });
    }, 3000);
  };

  handleButton = (name) => {
    switch (name) {
      case "setLiveStatus":
        this.setLiveStatus();
        break;
      case "setPauseStatus":
        this.setPauseStatus();
        break;
      case "setEndStatus":
        this.setEndStatus();
        break;
      case "setDeleteStatus":
        this.setDeleteStatus();
        break;
      case "setHubspotId":
        this.setHubspotId();
        break;
      case "setSalesforceId":
        this.setSalesforceId();
        break;
    }
  };

  displayNote = (e, formData) => {

    if (e.target.value === "SEND_MESSAGE" &&  store.getState().campaignWorkflowClickType == "Open") {
      this.state.formData["limits"] = this.props.limitsPerDay.maxopenmessageperday;
      this.setState({ formData });
    } else if (e.target.value === "SEND_MESSAGE") {
      this.state.formData["limits"] = this.props.limitsPerDay.maxmessageperday;
      this.setState({ formData });
    } else if (e.target.value === "SEND_EMAIL") {
      this.state.formData["limits"] = this.props.limitsPerDay.maxmessageperday;
      this.setState({ formData });
    } else if (e.target.value === "FOLLOW") {
      this.state.formData["limits"] = this.props.limitsPerDay.maxfollowperday;
      this.setState({ formData });
    } else if (e.target.value === "VISIT") {
      this.state.formData["limits"] = this.props.limitsPerDay.maxvisitperday;
      this.setState({ formData });
    } else if (e.target.value === "SEND_THANKS_MESSAGE") {
      this.state.formData["limits"] = this.props.limitsPerDay.maxmessageperday;
      this.setState({ formData });
    } else {
      this.state.formData["limits"] =
        this.props.limitsPerDay.maxconnectionperday;
      this.setState({ formData });
    }
  };

  editdisplayNote = (formData) => {

    const { stepname } = this.props.editableData;
    const {
      maxconnectionperday,
      maxfollowperday,
      maxmessageperday,
      maxopenmessageperday,
      maxvisitperday,
    } = this.props.limitsPerDay;
    if (stepname === "SEND_MESSAGE" && this.state.formData.open === 1) {
      this.state.formData["limits"] = maxopenmessageperday;
      this.setState({ formData, subject: this.state.formData["subject"] });
    }
    else if (stepname === "SEND_MESSAGE") {
      this.state.formData["limits"] = maxmessageperday;
      this.setState({ formData });
    } else if (stepname === "SEND_EMAIL") {
      this.state.formData["limits"] = maxmessageperday;
      this.setState({ formData, subject: this.state.formData["subject"] });
    } else if (stepname === "FOLLOW") {
      this.state.formData["limits"] = maxfollowperday;
      this.setState({ formData });
    } else if (stepname === "SEND_THANKS_MESSAGE") {
      this.state.formData["limits"] = maxmessageperday;
      this.setState({ formData }, () =>
        console.log(this.state.formData.limits)
      );
    } else if (stepname === "VISIT") {
      this.state.formData["limits"] = maxvisitperday;
      this.setState({ formData });
    } else {
      this.state.formData["limits"] = maxconnectionperday;
      this.setState({ formData });
    }
  };

  onChange = (e) => {
    const {
      target: { name, value },
    } = e;
    const { formData } = this.state;
    if (e.target.value === "CAMPAIGNMANAGER" || e.target.value === "ADMIN") {
      formData["customerid"] = "Select Customer";
      localStorage.removeItem("type");
    }
    if (e.target.value === "CUSTOMER") {
      localStorage.setItem("type", e.target.value);
    }
    if (e.target.name === "type") {
      localStorage.setItem("campaignType", e.target.value);

      this.setState({
        campaignType: e.target.value,
      });
    } else if (e.target.name === "dataoption") {
      this.setState({
        campaignDataOptionType: e.target.value,
      });
    }
    if (e.target.name === "stepname") {
      if (e.target.value === "SEND_INVITE") {
        this.setState({
          active: true,
          message: false,
          email: false,
          daysdelays: true,
          personalNoteActive: true,
          thanksActive: false,
        });
      } else if (e.target.value === "SEND_MESSAGE") {
        this.setState({
          message: true,
          email: false,
          active: false,
          daysdelays: true,
          personalNoteActive: false,
          thanksActive: false,
        });
      } else if (e.target.value === "SEND_EMAIL") {
        this.setState({
          message: false,
          email: true,
          active: false,
          daysdelays: true,
          personalNoteActive: false,
          thanksActive: false,
        });
      } else if (e.target.value === "SEND_THANKS_MESSAGE") {
        this.setState({
          message: false,
          email: false,
          active: false,
          daysdelays: true,
          personalNoteActive: false,
          thanksActive: true,
        });
      } else {
        this.setState({
          message: false,
          email: false,
          active: false,
          daysdelays: true,
          personalNoteActive: false,
          thanksActive: false,
        });
      }
    }

    if (e.target.name === "message" || e.target.name === "email") {
      this.setState({ textAreaData: e.target.value });
    }
    if (e.target.name === "subject") {
      this.setState({ subject: e.target.value });
    }
    if (e.target.name === "personalmessage") {
      this.setState({ personalNoteAreaData: e.target.value });
    }
    if (e.target.name === "replyMessage") {
      this.setState({ thanksAreaData: e.target.value });
    }

    if (e.target.name === "status") {
      formData[name] = parseInt(value);
    }

    if (e.target.name === "abm") {
      formData[name] = parseInt(value);
    }

    formData[name] = value;

    this.setState({
      formData,
    });

    if (this.state.formData.customerid && this.props.params2) {
      this.linkedinpro();
    }
    if (this.state.formData.linkedinid && this.props.params3) {
      this.getlinkedInCampaign();
    }
    if (e.target.name === "stepname") {
      this.displayNote(e, formData);
      this.props.setLimit(this.state.formData.limits); //for max limit on modal
    }
    if (e.target.name === "workflowtype") {

      if (
        e.target.value === "Standard" ||
        e.target.value === "Open" 
        ||
        e.target.value === "Standard Campaign Workflow"
       
        // ||
        // e.target.value === "Select Campaign Workflow"
      ) {
       // localStorage.setItem("stepType", e.target.value);
       
        this.setState({
          campaignWorkflowTypeCheck:
           e.target.value === "Standard Campaign Workflow" ? "" : e.target.value,
        
          //   e.target.value === "Select Campaign Workflow" ? "" : e.target.value,
        });
        
        store.dispatch({
          type: "CAMPAIGN_WORKFLOW_CLICK_TYPE",
          payload: e.target.value,
        });
      }
      // if (e.target.value === "Open" ){
      //   return <AddStepsSection2 />;
      // }else{
      //   return <AddStepsSection />;
      // }
      
    }
  };
  setState;

  handleDateChange = (date) => {
    const { formData } = this.state;
    formData["startdate"] = String(date);
    this.setState({ formData, starttime: date });
  };

  handleCheck = (e) => {
    const name = e.target.name;
    const { formData } = this.state;
    formData[name] = !formData[name];
    this.setState({ formData });
  };

  handleDelete = (row) => {
    const rows = this.state.rows.filter((m) => m._id !== row._id);
    this.setState({ rows });
  };

  MessageClick = (name) => {
    if (
      this.state.formData.stepname === "SEND_MESSAGE" ||
      this.state.formData.stepname === "SEND_EMAIL"
    ) {
      let data =
        this.state.textAreaData.substring(0, this.state.currentPosition) +
        name +
        this.state.textAreaData.substring(this.state.currentPosition);
      this.setState({ textAreaData: data });
      if (store.getState().isEditMode === true) {
        const { formData } = this.state;
        this.state.formData["message"] =
          this.state.formData["message"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["message"].substring(this.state.currentPosition);
        this.setState({ formData });
      } else if (
        store.getState().isEditMode === false &&
        this.props.editableData !== undefined
      ) {
        const { formData } = this.state;
        this.state.formData["message"] =
          this.state.formData["message"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["message"].substring(this.state.currentPosition);
        this.setState({ formData });
      } else {
        const { formData } = this.state;
        this.state.formData["message"] =
          this.state.formData["message"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["message"].substring(this.state.currentPosition);
        this.setState({ formData });
      }
    }
    if (this.state.formData.stepname === "SEND_THANKS_MESSAGE") {
      let data =
        this.state.thanksAreaData.substring(0, this.state.currentPosition) +
        name +
        this.state.thanksAreaData.substring(this.state.currentPosition);
      this.setState({ thanksAreaData: data });
      if (store.getState().isEditMode === true) {
        const { formData } = this.state;
        this.state.formData["replyMessage"] =
          this.state.formData["replyMessage"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["replyMessage"].substring(
            this.state.currentPosition
          );
        this.setState({ formData });
      } else if (
        store.getState().isEditMode === false &&
        this.props.editableData !== undefined
      ) {
        const { formData } = this.state;
        this.state.formData["replyMessage"] =
          this.state.formData["replyMessage"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["replyMessage"].substring(
            this.state.currentPosition
          );
        this.setState({ formData });
      } else {
        const { formData } = this.state;
        this.state.formData["replyMessage"] =
          this.state.formData["replyMessage"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["replyMessage"].substring(
            this.state.currentPosition
          );
        this.setState({ formData });
      }
    }
    if (this.state.formData.stepname === "SEND_INVITE") {
      let data =
        this.state.personalNoteAreaData.substring(
          0,
          this.state.currentPosition
        ) +
        name +
        this.state.personalNoteAreaData.substring(this.state.currentPosition);
      this.setState({ personalNoteAreaData: data });

      if (store.getState().isEditMode === true) {
        let { formData } = this.state;
        this.state.formData["personalmessage"] =
          this.state.formData["personalmessage"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["personalmessage"].substring(
            this.state.currentPosition
          );

        this.setState({ formData });
      } else if (
        store.getState().isEditMode === false &&
        this.props.editableData !== undefined
      ) {
        let { formData } = this.state;
        this.state.formData["personalmessage"] =
          this.state.formData["personalmessage"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["personalmessage"].substring(
            this.state.currentPosition
          );

        this.setState({ formData });
      } else {
        let { formData } = this.state;
        this.state.formData["personalmessage"] =
          this.state.formData["personalmessage"].substring(
            0,
            this.state.currentPosition
          ) +
          name +
          this.state.formData["personalmessage"].substring(
            this.state.currentPosition
          );

        this.setState({ formData });
      }
    }
  };

  setFilePreview = (filePreview) => {
    const { formData } = this.state;
    let image = formData.id + "-" + filePreview.name;
    var newFile = new File([filePreview], image, { type: filePreview.type });
    formData.profileImage = image;

    this.setState({ fileData: newFile, formData });
  };
  setFilePreview2 = (filePreview) => {
    const { formData } = this.state;

    let image = filePreview.name;
    var newFile = new File([filePreview], image, { type: filePreview.type });

    formData.campaignLogo = image;
    this.setState({ fileData: newFile, formData });
  };

  onUpdateData = (name) => {
    return this.state.formData[name];
  };

  renderFields = (props) => {
    const { touched, errors, handleChange, handleBlur } = props;
    const inputRef = React.useRef();
    const updateSelectionStart = () => {
      this.setState({ currentPosition: inputRef.current.selectionStart });
    };
    return this.props.formConfig.fields.map((item) => {
    //   debugger;
    //   var b = store.getState().addModalStep.length;
    //  var d =  this.state.formData.workflowtype;
    //  var j =store.getState().campaignWorkflowClickType;
      if (item.type === "input") {
        return (
          <div
            className={
              store.getState().addModalStep.length >= 1 && store.getState().campaignWorkflowClickType !== "Open" &&
              (this.state.formData.stepname === "SEND_THANKS_MESSAGE" ||
                this.state.formData.stepname === "SEND_MESSAGE") &&
              item.name === "limitperday" &&
              store.getState().addModalStep[0].stepname !== "SEND_MESSAGE"
                ? "input"
                : "Input"
            }
          >
            {item.isRequired ? (
              <div className="starIcon">
                {item.label}
                <span style={{ color: "red", marginLeft: "3px" }}>*</span>
              </div>
            ) : null}
            <TextField
              style={{ width: "100%" }}
              label={!item.isRequired ? item.label : ""}
              name={item.name}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={
                localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                  ? this.props.editableData && item.active === true
                    ? true
                    : this.state.formData.stepname === ""
                    ? true
                    : false
                  : item.disabled === true
                  ? false
                  : this.props.message === "First Name updated successfully" ||
                    this.props.message === "Company updated successfully" ||
                    this.props.message === "Position updated successfully" ||
                    this.props.message === "Surname updated successfully" ||
                    this.props.message === "Gender updated successfully" ||
                    this.props.message === "Email updated successfully" ||
                    this.props.message === "Phone updated successfully"
                  ? false
                  : true
              }
              onChange={handleChange}
              placeholder={item.placeholder}
              onBlur={handleBlur}
              variant="outlined"
              helperText={
                errors[item.name] && touched[item.name] && errors[item.name]
              }
              margin="normal"
              defaultValue={
                this.state.formData[item.name] !== undefined
                  ? this.state.formData[item.name]
                  : ""
              }
            />
          </div>
        );
      }

      // this is for personalNote TEXT AREA

      if (item.type === "personalNote") {
        return (
          this.state.personalNoteActive === true && (
            <div className="personalNote">
              <TextField
                style={{ width: "100%" }}
                label={item.label}
                name={item.name}
                inputRef={inputRef}
                onSelect={updateSelectionStart}
                onChange={this.onChange}
                onBlur={handleChange}
                multiline="true"
                variant="outlined"
                placeholder={item.placeholder}
                InputLabelProps={{
                  shrink: true,
                }}
                helperText={
                  errors[item.name] && touched[item.name] && errors[item.name]
                }
                margin="normal"
                value={
                  this.state.formData[item.name] !== undefined &&
                  (store.getState().isEditMode === true ||
                    this.props.mtitle === "EDIT_MODAL_STEP")
                    ? this.onUpdateData(item.name)
                    : this.state.personalNoteAreaData
                }
              />
            </div>
          )
        );
      }
      // ---------------------------------------------------------------------------------

      // -----------------------------------------------------------------------------------------------

      // This TEXT AREA specific for the message section in Campaign modal
      if (item.type === "messageArea" && this.state.email === true) {
        return (
          this.state.email === true && (
            <div className="emailArea">
              <div className="subjectFieldBox">
                <TextField
                  style={{ width: "100%" }}
                  label="Subject"
                  name="subject"
                  inputRef={inputRef}
                  onSelect={updateSelectionStart}
                  onChange={this.onChange}
                  variant="outlined"
                  rows="7"
                  placeholder="Enter Subject Here..."
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onBlur={handleChange}
                  margin="normal"
                  value={this.state.subject}
                />
              </div>
              <div className="emailFieldBox">
                {item.isRequired ? (
                  <div className="starIcon">
                    {item.label}
                    <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                  </div>
                ) : null}

                <TextField
                  style={{ width: "100%" }}
                  label={!item.isRequired ? item.label : ""}
                  name={item.name}
                  inputRef={inputRef}
                  onSelect={updateSelectionStart}
                  onChange={this.onChange}
                  multiline="true"
                  variant="outlined"
                  rows="7"
                  placeholder={item.placeholder}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={
                    localStorage.getItem("role") !== "CUSTOMER" ? false : true
                  }
                  onBlur={handleChange}
                  helperText={
                    errors[item.name] && touched[item.name] && errors[item.name]
                  }
                  margin="normal"
                  value={
                    this.state.formData[item.name] !== undefined &&
                    (store.getState().isEditMode === true ||
                      this.props.mtitle === "EDIT_MODAL_STEP")
                      ? this.onUpdateData(item.name)
                      : this.state.textAreaData
                  }
                />
              </div>
            </div>
          )
        );
      }
      if (item.type === "messageArea") {
        return (
          this.state.message === true && (
            <div className="messageArea">
              {item.isRequired ? (
                <div className="starIcon">
                  {item.label}
                  <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                </div>
              ) : null}
              <TextField
                style={{ width: "100%" }}
                label={!item.isRequired ? item.label : ""}
                name={item.name}
                inputRef={inputRef}
                onSelect={updateSelectionStart}
                onChange={this.onChange}
                multiline="true"
                variant="outlined"
                rows="7"
                placeholder={item.placeholder}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={
                  localStorage.getItem("role") !== "CUSTOMER" ? false : true
                }
                onBlur={handleChange}
                helperText={
                  errors[item.name] && touched[item.name] && errors[item.name]
                }
                margin="normal"
                value={
                  this.state.formData[item.name] !== undefined &&
                  (store.getState().isEditMode === true ||
                    this.props.mtitle === "EDIT_MODAL_STEP")
                    ? this.onUpdateData(item.name)
                    : this.state.textAreaData
                }
              />
            </div>
          )
        );
      }

      if (item.type === "thanksMessageArea") {
        return (
          this.state.thanksActive === true && (
            <div className="textarea">
              {item.isRequired ? (
                <div className="starIcon">
                  {item.label}
                  <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                </div>
              ) : null}
              <TextField
                style={{ width: "100%" }}
                label={!item.isRequired ? item.label : ""}
                name={item.name}
                inputRef={inputRef}
                onSelect={updateSelectionStart}
                onChange={this.onChange}
                onBlur={handleChange}
                multiline="true"
                variant="outlined"
                placeholder={item.placeholder}
                InputLabelProps={{
                  shrink: true,
                }}
                helperText={
                  errors[item.name] && touched[item.name] && errors[item.name]
                }
                margin="normal"
                value={
                  this.state.formData[item.name] !== undefined &&
                  (store.getState().isEditMode === true ||
                    this.props.mtitle === "EDIT_MODAL_STEP")
                    ? this.onUpdateData(item.name)
                    : this.state.thanksAreaData
                }
              />
            </div>
          )
        );
      }
      // ------------------------------------------------

      if (item.type === "button") {
        return (
          <div className="button">
            <Button
              startIcon={item.iconname}
              onClick={() => this.handleButton(item.funName)}
              disabled={
                this.state.pauseStatus === "LIVE" &&
                (item.disabled === true || item.delete === true)
                  ? true
                  : this.state.pauseStatus === "PAUSED" &&
                    (item.action === true || item.delete === true)
                  ? true
                  : this.state.pauseStatus === "COMPLETED"
                  ? true
                  : this.state.pauseStatus === "NOTSTARTED"
                  ? item.delete === true
                    ? false
                    : true
                  : false
              }
              color={item.color}
            >
              {item.buttontext}
            </Button>
          </div>
        );
      }
      if (item.type === "Button1") {
        return (
          <div className="button">
            <span className="tooltipButton">
              {store.getState().isEditMode === true &&
              this.props.editableData !== undefined ? (
                ""
              ) : (
                <span className="toolhint">
                  Please add a profile and then edit it to enable this button
                </span>
              )}
              <Button
                onClick={() =>
                  this.state.loadingData1 === "Token" ||
                  this.state.formData.hubspottoken
                    ? ""
                    : this.handleButton(item.functionName)
                }
                disabled={
                  this.state.loadingData1 === true ||
                  store.getState().isEditMode === false ||
                  (store.getState().isEditMode === true &&
                    this.props.editableData === undefined)
                }
                color={item.color}
              >
                {this.state.loadingData1 === false &&
                  !this.state.formData.hubspottoken && (
                    <span>{item.buttontext}</span>
                  )}
                {this.state.loadingData1 === true && (
                  <span>{item.connectingButton}</span>
                )}
                {this.state.loadingData1 === true && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "10px" }}
                  ></i>
                )}
                {(this.state.loadingData1 === "Token" ||
                  this.state.formData.hubspottoken) && (
                  <span>{item.connectedButton}</span>
                )}
              </Button>
            </span>
          </div>
        );
      }

      if (item.type === "Button") {
        return (
          <div className="button">
            <span className="tooltipButton">
              {store.getState().isEditMode === true &&
              this.props.editableData !== undefined ? (
                ""
              ) : (
                <span className="tooltiphint">
                  Please add a profile and then edit it to enable this button
                </span>
              )}
              <Button
                onClick={() =>
                  this.state.loadingData === "Token" ||
                  this.state.formData.salesforcetoken
                    ? ""
                    : this.handleButton(item.funName)
                }
                disabled={
                  this.state.loadingData === true ||
                  store.getState().isEditMode === false ||
                  (store.getState().isEditMode === true &&
                    this.props.editableData === undefined)
                }
                color={item.color}
              >
                {this.state.loadingData === false &&
                  !this.state.formData.salesforcetoken && (
                    <span>{item.buttontext}</span>
                  )}
                {this.state.loadingData === true && (
                  <span>{item.connectButton}</span>
                )}
                {this.state.loadingData === true && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginLeft: "10px" }}
                  ></i>
                )}
                {(this.state.loadingData === "Token" ||
                  this.state.formData.salesforcetoken) && (
                  <span>{item.connectedButton}</span>
                )}
              </Button>
            </span>
          </div>
        );
      }

      if (item.type === "list") {
        return (
          <div
            className={
              this.state.formData.stepname === "VISIT" ||
              this.state.formData.stepname === "FOLLOW" ||
              this.state.formData.stepname === "Select"
                ? "List"
                : "list"
            }
          >
            <ul>
              <li>
                <span style={{ color: "#2587e8" }}>
                  Use the below given variable to compose the message
                </span>
              </li>
              <li
                className={
                  this.state.formData.stepname === "VISIT" ||
                  this.state.formData.stepname === "FOLLOW" ||
                  this.state.formData.stepname === "Select"
                    ? "lidata"
                    : "li"
                }
                onClick={() => {
                  this.MessageClick("{gender} ");
                }}
              >
                Gender = {"{gender}"}
              </li>

              <li
                className={
                  this.state.formData.stepname === "VISIT" ||
                  this.state.formData.stepname === "FOLLOW" ||
                  this.state.formData.stepname === "Select"
                    ? "lidata"
                    : "li"
                }
                onClick={() => {
                  this.MessageClick("{firstname} ");
                }}
                name="first"
              >
                First Name = {"{firstname}"}
              </li>

              <li
                className={
                  this.state.formData.stepname === "VISIT" ||
                  this.state.formData.stepname === "FOLLOW" ||
                  this.state.formData.stepname === "Select"
                    ? "lidata"
                    : "li"
                }
                onClick={() => {
                  this.MessageClick("{Last_Name}");
                }}
              >
                Surname = {"{Last_Name}"}
              </li>
              <li
                className={
                  this.state.formData.stepname === "VISIT" ||
                  this.state.formData.stepname === "FOLLOW" ||
                  this.state.formData.stepname === "Select"
                    ? "lidata"
                    : "li"
                }
                onClick={() => {
                  this.MessageClick("{company} ");
                }}
              >
                Company = {"{company}"}
              </li>
              <li
                className={
                  this.state.formData.stepname === "VISIT" ||
                  this.state.formData.stepname === "FOLLOW" ||
                  this.state.formData.stepname === "Select"
                    ? "lidata"
                    : "li"
                }
                onClick={() => {
                  this.MessageClick("{email}");
                }}
              >
                Email = {"{email}"}
              </li>
              <li
                className={
                  this.state.formData.stepname === "VISIT" ||
                  this.state.formData.stepname === "FOLLOW" ||
                  this.state.formData.stepname === "Select"
                    ? "lidata"
                    : "li"
                }
                onClick={() => {
                  this.MessageClick("{phonenumber}");
                }}
              >
                Phone = {"{phonenumber}"}
              </li>
            </ul>
          </div>
        );
      }

      if (item.type === "datepicker") {
        return (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className="datepicker">
              <KeyboardDatePicker
                margin="normal"
                id="date-picker-dialog"
                label={item.label}
                InputLabelProps={{
                  shrink: true,
                }}
                minDate={item.minDate}
                placeholder={item.placeholder}
                required={item.required}
                disabled={
                  localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                    ? this.state.formData.startdate < new Date() &&
                      item.disabled === true
                      ? true
                      : false
                    : true
                }
                format="MM/dd/yyyy"
                value={this.state.formData[item.name] || null}
                onChange={this.handleDateChange}
                onBlur={handleChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                helperText={
                  errors[item.name] && touched[item.name] && errors[item.name]
                }
                keyboardIcon={
                  <img src={Calender} alt="" style={{ width: "17px" }} />
                }
              />
            </div>
          </MuiPickersUtilsProvider>
        );
      }

      if (item.type === "timepicker") {
        return (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className="timepicker">
              <KeyboardTimePicker
                margin="normal"
                id="time-picker"
                InputLabelProps={{
                  shrink: true,
                }}
                label={item.label}
                required={item.required}
                disabled={
                  localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                    ? this.state.starttime < new Date() &&
                      item.disabled === true
                      ? true
                      : false
                    : true
                }
                variant="outlined"
                placeholder={item.placeholder}
                value={this.state.starttime || null}
                onChange={this.handleDateChange}
                onBlur={handleChange}
                helperText={
                  errors[item.name] && touched[item.name] && errors[item.name]
                }
                KeyboardButtonProps={{
                  "aria-label": "change time",
                }}
                keyboardIcon={
                  <img src={Clock} alt="" style={{ width: "17px" }} />
                }
              />
            </div>
          </MuiPickersUtilsProvider>
        );
      }
      if (item.type === "anchor") {
        const ModalComponent = item.compo;

        if (!item.modalType) {
          return <ModalComponent />;
        }
      }
      if (item.type === "iconbutton") {
        return (
          <div className="iconbutton">
            <IconButton color={item.color} aria-label="">
              {item.iconbuttonname}
            </IconButton>
            <br />
          </div>
        );
      }

      if (item.type === "textarea") {
        return (
          this.state.active === true && (
            <div className="textarea">
              <TextField
                style={{ width: "100%" }}
                label={item.label}
                name={item.name}
                onChange={handleChange}
                multiline="true"
                variant="outlined"
                placeholder={item.placeholder}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={
                  localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                    ? false
                    : true
                }
                onBlur={handleBlur}
                helperText={
                  errors[item.name] && touched[item.name] && errors[item.name]
                }
                margin="normal"
                defaultValue={
                  this.state.formData[item.name] !== undefined
                    ? this.state.formData[item.name]
                    : ""
                }
              />
            </div>
          )
        );
      }
      // ---------------------------------------------------------------------

      if (item.type === "photo") {
        return (
          <div>
            <Dropzone
              formData={this.state.formData}
              setFilePreview={this.setFilePreview}
            />
          </div>
        );
      }
      if (item.type === "photo2") {
        return (
          <div>
            <Dropzone2
              formData={this.state.formData}
              setFilePreview={this.setFilePreview2}
            />
          </div>
        );
      }

      if (item.type === "table") {
        const ComponentName = item.compo;

        return (
          <React.Fragment>
            <div className="Table">
              <Typography>
                <Link to="#" className="addMorelink">
                  <ComponentName formData={this.state.formData} />
                </Link>
              </Typography>
              <Typography style={{ cursor: "none", color: "#babfbb" }}>
                {item.label}
              </Typography>
              <AddLinkedinModal />
            </div>
          </React.Fragment>
        );
      }

      if (item.type === "dynamicSelect2") {
        let options = [];
        options = this.props[item.data]
          ? this.props[item.data].map((i) =>
              i[item.key2] === undefined ? (
                <MenuItem
                  key={i.id}
                  value={i.id}
                  style={{
                    maxWidth: "270px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  {i[item.key1]}
                </MenuItem>
              ) : (
                <MenuItem
                  key={i.id}
                  value={i.id}
                  style={{
                    maxWidth: "270px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  {i[item.key1] + " " + i[item.key2]}
                </MenuItem>
              )
            )
          : null;
        options.unshift(
          <MenuItem
            key={item.placeholder}
            value={item.placeholder}
            style={{
              fontSize: "12px",
              maxWidth: "270px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
            }}
            disabled
          >
            {item.placeholder}
          </MenuItem>
        );
        return (
          <div className="staticSelect">
            {localStorage.getItem("type") === "CUSTOMER" ? (
              <div>
                {item.isRequired ? (
                  <div className="starIcon">
                    {item.label}
                    <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                  </div>
                ) : null}
                <TextField
                  style={{ width: "100%", textAlign: "left" }}
                  select
                  label={!item.isRequired ? item.label : ""}
                  name={item.name}
                  margin="normal"
                  onChange={this.onChange}
                  onBlur={handleChange}
                  touched={touched}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <img src={NextArrow} alt="" style={{ width: "7px" }} />
                    ),
                  }}
                  disabled={
                    localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                      ? (item.disabled &&
                          this.state.formData.role !== "CUSTOMER") ||
                        item.active ||
                        (this.state.formData.status !== "NOTSTARTED" &&
                          item.link)
                        ? true
                        : false
                      : true
                  }
                  variant="outlined"
                  value={
                    this.state.formData[item.name] !== undefined
                      ? this.state.formData[item.name] !== null
                        ? this.state.formData[item.name]
                        : item.placeholder
                      : null
                  }
                  helperText={
                    errors[item.name] && touched[item.name] && errors[item.name]
                  }
                >
                  {options}
                </TextField>
              </div>
            ) : (
              ""
            )}
          </div>
        );
      }

      if (item.type === "dynamicSelect") {
        let options = [];

        if (item.name === "datafromcampaign") {
        }

        let params3Options = this.state.EditcampaignTypeId
          ? this.state.params3
          : this.state.campaignDataOptionType === "Existing Campaign"
          ? this.state.params3
          : [];

        if (item.name === "datafromcampaign") {
          item.isRequired =
            this.state.campaignType === "Follow on Campaign" ||
            this.state.campaignType === "1st connection campaign" ||
            this.state.campaignType === "In mail campaign"
              ? true
              : false;
          item.disabled =
            this.state.campaignType !== "Follow on Campaign" &&
            this.state.campaignType !== "1st connection campaign" &&
            this.state.campaignType !== "In mail campaign"
              ? true
              : false;
        }
        options = this.props[item.data]
          ? this.props[item.data].map((i) =>
              i[item.key2] === undefined ? (
                <MenuItem
                  key={i.id}
                  value={i.id}
                  style={{
                    maxWidth: "270px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  {i[item.key1]}
                </MenuItem>
              ) : (
                <MenuItem
                  key={i.id}
                  value={i.id}
                  style={{
                    maxWidth: "270px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  {i[item.key1] + " " + i[item.key2]}
                </MenuItem>
              )
            )
          : item.name === "datafromcampaign"
          ? params3Options
            ? params3Options.map((i) => (
                <MenuItem
                  key={i.id}
                  value={i.id}
                  style={{
                    maxWidth: "270px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  {i[item.key1]}
                </MenuItem>
              ))
            : null
          : this.state.params2
          ? this.state.params2.map((i) => (
              <MenuItem
                key={i.id}
                value={i.id}
                style={{
                  maxWidth: "270px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "block",
                }}
              >
                {i[item.key1]}
              </MenuItem>
            ))
          : null;
        options.unshift(
          <MenuItem
            key={item.placeholder}
            value={item.placeholder}
            style={{
              fontSize: "12px",
              maxWidth: "270px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
            }}
            disabled
          >
            {item.placeholder}
          </MenuItem>
        );
        return (
          <div className="staticSelect">
            {item.isRequired ? (
              <div className="starIcon">
                {item.label}
                <span style={{ color: "red", marginLeft: "3px" }}>*</span>
              </div>
            ) : null}
            <TextField
              style={{ width: "100%", textAlign: "left" }}
              select
              label={!item.isRequired ? item.label : ""}
              name={item.name}
              margin="normal"
              onChange={this.onChange}
              onBlur={handleChange}
              touched={touched}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <img src={NextArrow} alt="" style={{ width: "7px" }} />
                ),
              }}
              disabled={
                localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                  ? (item.disabled &&
                      this.state.formData.role !== "CUSTOMER") ||
                    item.active ||
                    (this.state.formData.status !== "NOTSTARTED" && item.link)
                    ? true
                    : false
                  : true
              }
              variant="outlined"
              value={
                this.state.formData[item.name] !== undefined
                  ? this.state.formData[item.name]
                  : 0
              }
              helperText={
                errors[item.name] && touched[item.name] && errors[item.name]
              }
            >
              {options}
            </TextField>
          </div>
        );
      }

      if (item.type === "staticSelect") {
        if (item.name === "dataoption") {
          if (this.state.campaignType === "Nurture Campaign") {
            item.data = [{ name: "Normal Load", value: "Normal Load" }];
          } else if (
            this.state.campaignType === "Follow on Campaign" ||
            this.state.campaignType === "In mail campaign"
          ) {
            item.data = [
              { name: "Existing Campaign", value: "Existing Campaign" },
            ];
          } else {
            item.data = [
              { name: "Normal Load", value: "Normal Load" },
              { name: "Existing Campaign", value: "Existing Campaign" },
            ];
          }

          item.isRequired =
            this.state.campaignType === "Nurture Campaign" ||
            this.state.campaignType === "Follow on Campaign" ||
            this.state.campaignType === "1st connection campaign" ||
            this.state.campaignType === "In mail campaign"
              ? true
              : false;
          item.disabled =
            this.state.campaignType !== "Nurture Campaign" &&
            this.state.campaignType !== "Follow on Campaign" &&
            this.state.campaignType !== "1st connection campaign" &&
            this.state.campaignType !== "In mail campaign"
              ? true
              : false;
        }
        let options = [];
        options = item.data.map((i) => (
          <MenuItem
            key={i.name}
            value={i.value}
            style={{ fontSize: "12px" }}
            disabled={
              store.getState().addModalStep.length >= 1 && store.getState().campaignWorkflowClickType != "Open" &&
              store.getState().addModalStep[0].stepname === "SEND_MESSAGE"
                ? i.value !== "SEND_MESSAGE"
                  ? true
                  : false
                : false
            }
          >
            {i.name}
          </MenuItem>
        ));
       // debugger;
        if (
          item.label === "Campaign Workflow" &&
          !this.state.formData.opencontact
        ) {
          options = options.filter((option) => option.props.value !== "Open");
        }
        if (
          this.props.formConfig.title === "Edit Campaign" &&
          store.getState().formData.workflowtype === "Open"
        ) {
          options = options.filter(
            (option) => option.props.value !== "Standard"
          );
          options.push(
            <MenuItem
              key="Standard Campaign Workflow"
              value="Standard"
              style={{ fontSize: "12px" }}
            >
              Standard Campaign Workflow
              {/* key="Select Campaign Workflow"
              value="Select Campaign Workflow"
              style={{ fontSize: "12px" }}
            >
              Select Campaign Workflow */}
            </MenuItem>
          );
        }
        if (
          this.props.formConfig.title === "Add Step" &&
          (store.getState().campaignWorkflowClickType === "Open" ||
            this.state.formData.workflowtype === "Open")
        ) {
         
          options = options.filter(
            (option) =>
              option.props.value !== "FOLLOW" &&
              option.props.value !== "SEND_INVITE" &&
              option.props.value !== "SEND_THANKS_MESSAGE" &&
              option.props.value !== "SEND_EMAIL"  
            //  option.props.value !== "SEND_MESSAGE"

          );
        }
        options.unshift(
          <MenuItem
            key={item.placeholder}
            value={item.placeholder}
            style={{ fontSize: "12px" }}
            disabled
          >
            {item.placeholder}
          </MenuItem>
        );
        return (
          <div className="staticSelect">
            {item.isRequired ? (
              <div className="starIcon">
                {item.label}
                <span style={{ color: "red", marginLeft: "3px" }}>*</span>
              </div>
            ) : null}
            <TextField
              style={{ width: "100%", textAlign: "left" }}
              select
              label={!item.isRequired ? item.label : ""}
              name={item.name}
              margin="normal"
              disabled={
                item.disabled === true
                  ? true
                  : localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                  ? this.props.editableData && item.active
                    ? true
                    : false
                  : true
              }
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <img src={NextArrow} alt="" style={{ width: "7px" }} />
                ),
              }}
              variant="outlined"
              defaultValue={
                this.state.formData[item.name] !== undefined
                  ? this.state.formData[item.name]
                  : null
              }
              onBlur={handleChange}
              onChange={this.onChange}
              helperText={
                errors[item.name] && touched[item.name] && errors[item.name]
              }
            >
              {options}
            </TextField>
          </div>
        );
      }

      //-------------dynamic input field-------------------------//

      if (item.type === "dynamicInput") {
        return (
          this.state.daysdelays === true && (
            <div className="Input">
              {item.isRequired ? (
                <div className="starIcon">
                  {item.label}
                  <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                </div>
              ) : null}
              <TextField
                style={{ width: "100%" }}
                label={!item.isRequired ? item.label : ""}
                name={item.name}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleChange}
                placeholder={item.placeholder}
                onBlur={handleBlur}
                variant="outlined"
                disabled={this.state.formData.stepname === "" ? true : false}
                helperText={
                  errors[item.name] && touched[item.name] && errors[item.name]
                }
                margin="normal"
                defaultValue={
                  this.state.formData[item.name] !== undefined
                    ? this.state.formData[item.name]
                    : ""
                }
              />
            </div>
          )
        );
      }

      // -----------------------------------------------------------------------------------------------

      if (item.type === "radio") {
        const options = item.options.map((item) => {
          return (
            <FormControlLabel
              value={item.value}
              control={<Radio />}
              label={item.name}
            />
          );
        });
        return (
          <div className="Radio">
            <FormControl component="fieldset">
              <FormLabel
                component="legend"
                style={{
                  textAlign: "left",
                  fontSize: "12px",
                }}
              >
                {item.label}
              </FormLabel>
              <RadioGroup
                aria-label={item.label}
                name={item.name}
                onBlur={this.onChange}
                onChange={handleChange}
                defaultValue={
                  this.state.formData[item.name] !== undefined
                    ? this.state.formData[item.name]
                    : null
                }
              >
                {options}
              </RadioGroup>
            </FormControl>
          </div>
        );
      }

      if (item.type === "password") {
        return (
          <div className="Password">
            {item.isRequired ? (
              <div className="starIcon">
                {item.label}
                <span style={{ color: "red", marginLeft: "3px" }}>*</span>
              </div>
            ) : null}
            <TextField
              style={{ width: "100%" }}
              label={!item.isRequired ? item.label : ""}
              name={item.name}
              placeholder={item.placeholder}
              onChange={handleChange}
              type="password"
              InputLabelProps={{
                shrink: true,
              }}
              helperText={
                this.props.editableData && this.props.className === "userForm"
                  ? !this.state.formData.hasOwnProperty("confirmPassword") &&
                    errors[item.name] &&
                    errors[item.name]
                  : errors[item.name] && touched[item.name] && errors[item.name]
              }
              defaultValue={
                this.state.formData[item.name] !== undefined
                  ? this.state.formData[item.name]
                  : null
              }
              margin="normal"
              variant="outlined"
            />
          </div>
        );
      }
      if (item.type === "checkbox") {
        return (
          <div className="Checkbox">
            <FormControlLabel
              control={
                <Checkbox
                  name={item.name}
                  value={item.value}
                  checked={
                    this.state.formData[item.name] !== undefined
                      ? this.state.formData[item.name]
                      : null
                  }
                  onChange={this.handleCheck}
                  disabled={
                    localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                      ? false
                      : true
                  }
                  color="primary"
                />
              }
              label={item.label}
            />
          </div>
        );
      }

      if (item.type === "heading") {
        if (!item.modalType) {
          return (
            <div>
              <h4>{item.label}</h4>
            </div>
          );
        }
      }

      if (item.type === "note") {
        return (
          <div
            className={
              store.getState().addModalStep.length > 0 &&  store.getState().campaignWorkflowClickType != "Open" &&
              (this.state.formData.stepname === "SEND_MESSAGE" ||
                this.state.formData.stepname === "SEND_THANKS_MESSAGE") &&
              store.getState().addModalStep[0].stepname !== "SEND_MESSAGE"
                ? "Notes"
                : "notes"
            }
          >
            <span style={{ color: "orange" }}>
              {item.label}
              {this.state.formData.limits}
            </span>
          </div>
        );
      }

      if (item.type === "label") {
    
        return <AddStepsSection />;
      }
    });
  };

  getInitialValues(inputs) {
    if (this.props.editableData !== undefined) {
      return this.props.editableData;
    } else {
      const initialValues = {};
      inputs.forEach((field) => {
        if (!initialValues[field.name]) {
          initialValues[field.name] = field.value;
        }
      });
      return initialValues;
    }
  }

  holdModalData = () => {
    if (this.props.mtitle === "ADD_LINKEDIN") {
      store.dispatch({
        type: this.props.mtitle,
        modalData: this.state.formData,
      });
      this.props.modalClose();
    } else {
      if (this.props.editableData !== undefined) {
        store.dispatch({
          type: this.props.mtitle,
          modalData: this.state.formData,
        });
      } else {
        if (this.props.mtitle === "ADD_STEP") {
          let updatedFormData = {
            ...this.state.formData,
            open:
              store.getState().campaignWorkflowClickType !== "" &&
              store.getState().campaignWorkflowClickType === "Standard"
                ? 0
                : 1,
          };
          this.setState({ formData: updatedFormData });
        }
        if (store.getState()[this.props.storeArray].length === 0) {
          store.dispatch({
            type: this.props.mtitle,
            modalData: this.state.formData,
          });
        } else {
          let data = store.getState()[this.props.storeArray];
          var status = true;
          for (var i = 0; i < data.length; i++) {
            if (
              data[i].stepname === this.state.formData.stepname &&
              this.state.formData.stepname !== "SEND_MESSAGE" &&
              data[i]?.open === this.state?.formData?.open
            ) {
              status = false;
              swal("You have already selected this step", { icon: "error" });
            }
          }
          if (status === true) {
            store.dispatch({
              type: this.props.mtitle,
              modalData: this.state.formData,
            });
          }
          this.props.modalClose();
        }
      }
      this.props.modalClose();
    }
  };

  buildQueryParams = (id) => {
    if (this.props.className === "customerForm" && this.props.query1) {
      let linkedIn = store.getState().addLinkedinStep;
      linkedIn.map((linked) => {
        linked["customerid"] = id;
        linked["active"] = 1;
      });
      return linkedIn;
    } else if (this.props.className === "campaignForm" && this.props.query1) {
      let addCampaignStep = store.getState()[this.props.storeArray];

      let openSequence = 0;
      let closedSequence = 0;
      addCampaignStep.forEach((addstep) => {
        addstep["campaignid"] = id;
        addstep["active"] = 1;
        if (addstep.open === 0) {
          // Closed step
          closedSequence += 1;
          addstep["sequence"] = closedSequence;
        } else {
          // Open step
          openSequence += 1;
          addstep["sequence"] = openSequence;
          addstep["active"] = this.state.formData.opencontact ? 1 : 0;
        }
      });
      return addCampaignStep;
    }
  };

  buildParams = (id) => {
    if (
      this.props.mtitle === "ADD_LINKEDIN" &&
      store.getState().isEditMode === true
    ) {
      this.state.formData["customerid"] = id;
      this.state.formData["active"] = 1;
      this.props.OnEditData(this.state.formData);
      return this.state.formData;
    } else if (
      this.props.mtitle === "ADD_STEP" &&
      store.getState().isEditMode === true
    ) {
      this.state.formData["campaignid"] = id;
      this.state.formData["active"] = 1;
      let addCampaignStep = store.getState().addModalStep;

      // Find the last sequence with open - for edit step
      const lastOpen0Sequence = Math.max(
        ...addCampaignStep
          .filter((step) => step.open === 0)
          .map((step) => step.sequence),
        0
      );
      const lastOpen1Sequence = Math.max(
        ...addCampaignStep
          .filter((step) => step.open === 1)
          .map((step) => step.sequence),
        0
      );

      // this.state.formData["sequence"] = addCampaignStep.length + 1;
      this.state.formData["sequence"] =
        store.getState().campaignWorkflowClickType !== "" &&
        store.getState().campaignWorkflowClickType === "Standard"
          ? lastOpen0Sequence + 1
          : lastOpen1Sequence + 1;
      // edit campign step - open
      this.state.formData["open"] =
        store.getState().campaignWorkflowClickType !== "" &&
        store.getState().campaignWorkflowClickType === "Standard"
          ? 0
          : 1;

      this.props.OnEdit(this.state.formData);
      return this.state.formData;
    }
  };

  submitHandler = (e) => {
    if (this.props.editableData !== undefined) {
      e["id"] = this.props.editableData.id;
      const keys = Object.keys(e);
      const updatedFields = {};
      keys.map((item, key) => {
        key = { key };

        if (
          store.getState().isEditMode === true &&
          this.props.mtitle === "EDIT_MODAL_STEP"
        ) {
          this.state.formData.sequence = this.props.editableData.sequence;
        }
        this.state.formData["updatedby"] = localStorage.getItem("id");
        this.state.formData["updatedat"] = new Date();
        // add update filed in the updatedFields
        if (
          item.trim().toLowerCase().endsWith("message") &&
          e[item] !== e.message
        ) {
          updatedFields.message = e[item] || e.message;
        }
        if (this.props.editableData[item] !== e[item]) {
          updatedFields[item] = e[item];
        }

        return (this.state.formData[item] = e[item]);
      });
      if (
        store.getState().isEditMode === true &&
        this.props.mtitle === "EDIT_MODAL_STEP"
      ) {
        const logdata = {
          data: {
            stepid: this.props.editableData.id,
            updatedby: localStorage.getItem("id"),
            ...updatedFields,
          },
        };
        fetchMethod(stepLogs, logdata)
          .then((res) => res.json())
          .then((response) => {})
          .catch((e) => console.log(e));
      }
      delete this.state.formData.limits;

      e = this.state.formData;
    } else {
      const keys = Object.keys(this.state.formData);

      if (this.props.formConfig.title === "AddCampaignForm") {
        this.state.formData["status"] = "NOTSTARTED";
      }

      keys.map((item) => {
        if (this.props.className === "ChangePassword") {
          this.state.formData["id"] = localStorage.getItem("id");
        }
        this.state.formData["createdby"] = localStorage.getItem("id");
        this.state.formData["updatedby"] = localStorage.getItem("id");
        if (this.props.className === "campaignForm") {
          this.state.formData["campaignadminid"] = localStorage.getItem("id");
        }
        if (
          this.state.formData.role === "CUSTOMER" &&
          this.state.formData.customerid === "Select Customer" &&
          this.props.className === "userForm"
        ) {
          e["customerid"] = "Select Customer";
        }

        return this.state.formData[item] !== ""
          ? ""
          : (this.state.formData[item] = e[item]);
      });
    }

    if (
      this.props.formConfig.title === "Add Step" &&
      this.state.formData.stepname === "SEND_INVITE"
    ) {
      let { formData } = this.state;
      formData.message = formData.personalmessage;
      this.setState({ formData });
    }

    if (
      this.props.formConfig.title === "Add Step" &&
      this.state.formData.stepname === "SEND_THANKS_MESSAGE"
    ) {
      let { formData } = this.state;
      formData.message = formData.replyMessage;

      this.setState({ formData });
    }

    delete this.state.formData.confirmPassword;

    delete this.state.formData.list;
    delete this.state.formData.personalmessage;
    delete this.state.formData.replyMessage;

    if (this.props.className === "campaignForm") {
      delete this.state.formData.starttime;
    }

    if (
      this.state.formData.customerid === "Select Customer" &&
      this.props.className === "userForm"
    ) {
      this.state.formData.customerid = null;
    }
    if (
      this.state.formData.startdate !== undefined &&
      (this.props.className === "campaignForm" ||
        this.props.className === "EditCampaign")
    ) {
      var date = new Date(this.state.formData.startdate);
      var tz = -1 * date.getTimezoneOffset();
      this.state.formData.startdate = new Date(date.getTime() + tz * 60000);
    }

    if (!this.props.editableData) {
      var count = 1;
      let addCampaignStep = store.getState().addModalStep;

      for (let i = 0; i < addCampaignStep.length; i++) {
        if (
          this.state.formData.stepname === addCampaignStep[i].stepname &&
          addCampaignStep[i].stepname !== "SEND_MESSAGE" &&
          addCampaignStep[i]?.open ===
            (store.getState().campaignWorkflowClickType === "Standard" ? 0 : 1)
        ) {
          swal("You have already selected this step", { icon: "error" });
          this.props.modalClose();
          return;
        }
        if (
          this.state.formData.stepname === addCampaignStep[i].stepname &&
          addCampaignStep[i].stepname === "SEND_MESSAGE"
        ) {
          count++;
        }
      }
      if (count > 5) {
        swal("Max step limit reached", { icon: "error" });
        this.props.modalClose();
        return;
      }
    }

    const test = this.props.editableData
      ? this.props.message === "Company updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { organization: this.state.formData.organization },
          }
        : this.props.message === "Position updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { designation: this.state.formData.designation },
          }
        : this.props.message === "First Name updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { fname: this.state.formData.fname },
          }
        : this.props.message === "Country updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { country: this.state.formData.country },
          }
        : this.props.message === "State updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { state: this.state.formData.state },
          }
        : this.props.message === "Surname updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { surname: this.state.formData.surname },
          }
        : this.props.message === "Email updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { email: this.state.formData.email },
          }
        : this.props.message === "Phone updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { phonenumber: this.state.formData.phonenumber },
          }
        : this.props.message === "Gender updated successfully"
        ? {
            where: { id: this.state.formData.id },
            data: { gender: this.state.formData.gender },
          }
        : {
            id: { id: this.state.formData.id },
            data: this.state.formData,
          }
      : store.getState().isEditMode === true
      ? { data: this.buildParams(store.getState().id) }
      : this.props.className === "ChangePassword"
      ? {
          id: this.state.formData.id,
          oldPassword: this.state.formData.oldPassword,
          newPassword: this.state.formData.newPassword,
        }
      : { obj: this.state.formData };

    this.props.query !== ""
      ? fetchMethod(this.props.query, test)
          .then((res) => res.json())
          .then((response) => {
            const message =
              response.data[this.props.query.definitions[0].name.value];

            if (
              store.getState().isEditMode === true &&
              (this.props.mtitle === "ADD_LINKEDIN" ||
                this.props.mtitle === "ADD_STEP")
            ) {
              this.state.formData["id"] = message.id;
            }
            if (
              this.props.query2 &&
              !response.errors &&
              this.props.className === "userForm" &&
              this.state.formData.newPassword !== undefined
            ) {
              const test = {
                id: this.state.formData.id,
                newPassword: this.state.formData.newPassword,
              };
              fetchMethod(this.props.query2, test)
                .then((res) => res.json())
                .then((res) => {
                  const message =
                    res.data[this.props.query2.definitions[0].name.value];
                  if (message === null && !res.errors) {
                    this.props.modalClose();
                    swal({ text: this.props.message, icon: "success" });
                    return this.props.updateData ? this.props.updateData() : "";
                  }
                })
                .catch((e) => console.log(e));
            } else if (this.props.query1 && !response.errors) {
              let params = this.buildQueryParams(message.id);
              let test1 = {
                data: params,
              };

              fetchMethod(this.props.query1, test1)
                .then((res) => res.json())
                .then((response) => {
                  const message1 =
                    response.data[this.props.query1.definitions[0].name.value];
                  if (message1 !== null && this.props.editableData) {
                    this.props.modalClose();
                    swal({ text: this.props.message, icon: "success" });
                    return this.props.updateData ? this.props.updateData() : "";
                  } else if (message1 !== null) {
                    this.props.modalClose();
                    swal({ text: this.props.message, icon: "success" });
                    return this.props.updateData ? this.props.updateData() : "";
                  } else {
                    swal("Please try again", { icon: "error" });
                  }
                })
                .catch((e) => console.log("Error:", e));
            } else {
              if (message !== null && this.props.editableData) {
                if (this.props.onButton === "false") {
                  swal({ text: this.props.message, icon: "success" });
                  return this.props.updateData ? this.props.updateData() : "";
                }
                if (this.props.className === "EditProfile") {
                  let formData = new FormData();
                  formData.append("file", this.state.fileData);
                  let xhttp = new XMLHttpRequest();

                  xhttp.open(
                    "POST",
                    `${profileImageUrl.url}` +
                      `${localStorage.getItem("token")}`
                  );
                  xhttp.send(formData);

                  xhttp.onreadystatechange = function () {
                    if (xhttp.readyState === XMLHttpRequest.DONE) {
                    }
                  };
                }
                if (this.props.className === "EditCampaign") {
                  let formData = new FormData();
                  formData.append("campaignslogo", this.state.fileData);
                  let xhttp = new XMLHttpRequest();

                  xhttp.open(
                    "POST",
                    `${campaignImageUrl.url}` +
                      `${localStorage.getItem("token")}`
                  );
                  xhttp.send(formData);

                  xhttp.onreadystatechange = function () {
                    if (xhttp.readyState === XMLHttpRequest.DONE) {
                    }
                  };
                }
                this.props.modalClose();
                swal({ text: this.props.message, icon: "success" });
                return this.props.updateData
                  ? this.props.updateData()
                  : this.props.mtitle === "EDIT_LINKEDIN"
                  ? this.props.EditLinkedinData(this.state.formData)
                  : this.props.EditData(this.state.formData);
              } else if (message !== null) {
                if (this.props.onButton === "false") {
                  swal({
                    text: this.props.message,
                    icon: "success",
                  });
                  return this.props.updateData ? this.props.updateData() : "";
                }
                this.props.modalClose();
                swal({ text: this.props.message, icon: "success" });
                return this.props.updateData ? this.props.updateData() : "";
              } else if (
                message === null &&
                (this.props.className === "userForm" ||
                  this.props.className === "customerForm") &&
                response.errors
              ) {
                swal("This email-id already exists", { icon: "error" });
                this.state.formData.email = "";
                return;
              } else if (
                message === null &&
                this.props.className === "ChangePassword" &&
                !response.errors
              ) {
                this.props.modalClose();
                swal({ text: this.props.message, icon: "success" });
              } else if (
                message === null &&
                this.props.className === "ChangePassword" &&
                response.errors
              ) {
                swal("Incorrect old password!", { icon: "error" });
                this.state.formData.oldPassword = "";
              } else if (
                this.props.message === "First Name updated successfully" &&
                response.errors
              ) {
                swal("First Name updated unsuccessfully", { icon: "error" });
              } else {
                swal("Please try again", { icon: "error" });
              }
            }
          })
          .catch((e) =>
            swal({ title: "Unable to reach server", icon: "warning" })
          )
      : this.holdModalData();
  };
  render() {
    const initialValues = this.getInitialValues(this.props.formConfig.fields);

    return (
      <div className="formWidth">
        <Formik
          onSubmit={this.submitHandler}
          validationSchema={this.props.formValidation}
          initialValues={initialValues}
        >
          {(props) => {
            const { isSubmitting } = props;
            return (
              <Form className="sideForm">
                {this.renderFields(props)}
                <DialogActions>
                  {!this.props.onButton && (
                    <Button
                      style={{
                        fontFamily: "inherit",
                        fontSize: "12px",
                        border: "1px solid #ddd",
                        background: "#f1f1f1",
                        borderRadius: "6px",
                      }}
                      onClick={this.props.modalClose}
                    >
                      Cancel  
                    </Button>
                  )}
                  <Button
                    type="submit"
                    style={{
                      background: "#0456d9",
                      fontFamily: "inherit",
                      fontSize: "12px",
                      color: "white",
                      border: "1px solid",
                      borderRadius: "6px",
                    }}
                    disabled={isSubmitting}
                  >
                    {this.props.buttonName}
                  </Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { addLinkedinStep } = state;
  return { addLinkedinStep };
};

const mapDispatchToProps = (dispatch) => {
  return {
    OnEdit: (editLinkedinData) =>
      dispatch({ type: "ADD_STEP", modalData: editLinkedinData }),
    EditData: (data) => dispatch({ type: "EDIT_MODAL_STEP", LinkedinId: data }),
    getName: (data) => dispatch({ type: "STEPS_NAME", stepname: data }),
    OnEditData: (editLinkedinData) =>
      dispatch({ type: "ADD_LINKEDIN", modalData: editLinkedinData }),
    EditLinkedinData: (data) => {
      dispatch({ type: "EDIT_LINKEDIN", LinkedinId: data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormComponent);
